<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/articleIndex/articleList' }"
          >买手图文管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>买手图文详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-rowl">
        <div class="baseinfo">
          <div class="tit">{{ dataItem.at_topic }}</div>
          <div class="tags flex-rowl">
            <div
              v-for="(item, index) in dataItem.typeidArr"
              :key="index"
              class="tag"
            >
              #{{ item }}
            </div>
          </div>
          <div class="data">{{ dataItem.createdate | formatDate }}</div>
          <div class="intro_slide_state">
            <div class="txt">
              图文简介：<span>{{ dataItem.at_intro }}</span>
            </div>
            <div class="txt">
              关联货架：<span>{{ dataItem.slidstr }}</span>
            </div>
            <div class="txt">
              审核状态：<span>{{ dataItem.checkstate }}</span>
            </div>
          </div>
          <div class="banner_wrap flex-rowl">
            <div
              class="banner_item"
              v-for="(item, index) in bannerList"
              :key="index"
            >
              <el-image
                style="width: 100px; height: 100px"
                :src="item"
                fit="cover"
                :preview-src-list="bannerList"
              ></el-image>
            </div>
          </div>
        </div>
        <div class="detail_wrap">
          <div class="tit">图文详情：</div>
          <div
            class="detail_item"
            v-for="(item, index) in contentList"
            :key="index"
          >
            <template v-if="item.conttype == 1">
              <div class="image_box">
                <img :src="item.picurl" alt="" />
              </div>
            </template>
            <template v-if="item.conttype == 2">
              <div class="video_box">
                <video :src="item.videourl" controls></video>
              </div>
            </template>
            <template v-if="item.conttype == 3">
              <div class="txt">
                {{ item.details }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div
        class="btn"
         @click="handleEdit(dataItem.id)"
      >
        操作
      </div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getArticleDetail } from "../../api/article";
import { calculator } from "../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "articleDetail",
  data() {
    return {
      loading: false,
      qyid: "",
      dataItem: "",
      type: "",
      id: "",
      bannerList: [],
      contentList: [], // 主要内容
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getArticleDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 订单列表
    getArticleDetail(id) {
      this.loading = true;
      getArticleDetail({ id }).then((res) => {
        // banner 的转换
        let bannerList = Object.keys(res)
          .filter((key) => key.startsWith("banner") && res[key]) // 添加条件检查属性值是否非空
          .map((key) => res[key]);
        res.typeidArr = res.typeidstr ? res.typeidstr.split(",") : [];
        this.dataItem = res;
        this.bannerList = bannerList;
        (this.contentList = res.videopic), (this.loading = false);
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$message.warning("即将开放");
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleEdit(id) {
      this.encryptstringadd("articleEdit", { id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_container {
    align-items: flex-start;
    flex-flow: wrap;
    .content_wrap {
      .baseinfo {
        width: 40%;
        .tit {
          font-size: 14px;
        }
        .tags {
          margin: 10px 0;
          font-size: 12px;
          color: #236f96;
          .tag {
            margin-right: 20px;
          }
        }
        .data {
          font-size: 12px;
          color: #a1a1a1;
        }
        .banner_wrap {
          margin: 20px 0;
          flex-wrap: wrap;
          .banner_item {
            margin-right: 10px;
            margin-bottom: 10px;
            img {
              height: 100% !important;
            }
          }
        }
        .intro_slide_state {
          margin-top: 10px;
          .txt {
            font-size: 14px;
            span {
              font-size: 12px;
            }
            &:nth-child(2) {
              margin: 10px 0;
            }
          }
        }
      }
      .detail_wrap {
        width: 20%;
        .tit {
          font-size: 14px;
          margin-bottom: 15px;
        }
        .detail_item {
          margin-bottom: 10px;
          .image_box {
            width: 100%;

            img {
              width: 100%;
            }
          }
          .video_box {
            width: 100%;
            video {
              width: 100%;
            }
          }
          .txt {
            font-size: 12px;
          }
        }
      }
    }
  }
  .form_footer {
    .btn {
      &.disabled {
        background: #a6a6a6;
      }
    }
  }
}
img {
  // width: auto !important;
}
</style>